import React from "react";

import { v4 as uuid_v4 } from "uuid";

import './FooterItems.css';
const FooterItems = (props) => {
    return (
        <div className={`footer-items-wrapper ${props.className}`}>
            <h3 className="footer-items-title">{props.title}</h3>
            {props.items.map((item)=> (
                <p className="footer-item" key={uuid_v4()}>{item}</p>
            ))}

        </div>
    )
}

export default FooterItems;